export interface SearchListItemProps {
  title?: string;
  description?: string;
  linkURL?: string;
  fileType?: string;
}

function getFileIcon(fileType?: string): string {
  const typeMap: Record<string, string> = {
    pdf: '/icons/filetype_pdf.png',
    docx: '/icons/filetype_docx.png'
  };

  if (!fileType) return '/icons/filetype_na.png';
  return typeMap[fileType.toLowerCase()] ?? '/icons/filetype_na.png';
}


function SearchListItem(props: SearchListItemProps) {
  const icon_path = getFileIcon(props.fileType);
  const hasLink = Boolean(props.linkURL);

  const content = (
    <div
      className="w-full border border-light-border rounded p-4 shadow-sm cursor-default
                 flex flex-col gap-3
                 xl:flex-row xl:items-start"
    >
      {/*
        Icon + text always share an inner row so they stay anchored together
        on mobile, rather than the icon becoming an orphaned top element.
      */}
      <div className="flex flex-row items-start gap-3 flex-1 min-w-0">
        <div className="text-2xl shrink-0">
          <img
            src={icon_path}
            alt={
              props.fileType
                ? `${props.fileType.toUpperCase()} file icon`
                : 'File icon'
            }
            className="w-8 h-8 text-sm"
          />
        </div>

        <div className="relative w-full flex-1 min-w-0">
          <button>
            <div className="font-bold text-light-text-link xl:truncate overflow-auto">
              {props.title || 'Untitled'}
            </div>
          </button>
          {props.description && (
            <div className="text-sm text-light-text mt-1 line-clamp-2">
              {props.description}
            </div>
          )}
        </div>
      </div>

      <button
        className="shrink-0
                   w-full xl:w-auto
                   px-2 py-1 text-sm
                   text-light-text-alt bg-light-main border border-light-border rounded
                   hover:bg-light-main-hover duration-200 ease-in-out cursor-pointer"
        aria-label={`Download ${props.title || 'item'}`}
        onClick={(e) => {
          if (!hasLink) e.preventDefault();
        }}
      >
        Download
      </button>
    </div>
  );

  if (hasLink) {
    return (
      <a href={props.linkURL} className="block no-underline" download>
        {content}
      </a>
    );
  }

  return content;
}


export default SearchListItem;
